import React from "react";
import SVG from "react-inlinesvg";
import { BreakPoint } from "tsi-common-react/src/models/screen";
import { t } from "ttag";

import { getWindow } from "@thelabnyc/thelabui/src/utils/dom";

import iconCaretDown from "../../../svg/caret-down.svg";
import iconCaretUp from "../../../svg/caret-up.svg";
import { IMenuCategoryLink } from "../../menu.interface";

interface IProps {
    isMobile: boolean;
    linkID: number;
    linkObject: IMenuCategoryLink;
    openModal: (
        event: React.MouseEvent<HTMLElement>,
        linkObject: IMenuCategoryLink,
    ) => void;
    openedLink?: string;
}

export const CategoryLink = ({
    isMobile,
    linkID,
    linkObject,
    openModal,
    openedLink,
}: IProps): React.ReactNode => {
    if (isMobile) {
        // To make the mobile subnav not tab focusable so that trapFocus from helpers.ts works properly,
        // only render the mobile subnav at the mobile breakpoint.
        const window = getWindow();
        if (window && window.innerWidth > BreakPoint.MEDIUM) {
            return null;
        }
        return (
            <button
                key={linkID}
                aria-label={t`Toggle ${linkObject.value.title} Menu`}
                aria-haspopup="dialog"
                className="main-dropdown-menu__mobile main-dropdown-menu__mobile-link"
                onClick={(e) => {
                    openModal(e, linkObject);
                }}
                data-subnav-link={linkID}
                tabIndex={0}
            >
                {/* TODO(i18n): title comes from CMS and should be translated there, not here */}
                {linkObject.value.title}{" "}
                <SVG
                    src={iconCaretDown}
                    className="main-dropdown-menu__mobile-shop-icon"
                    title={t`Show Menu Icon`}
                    aria-hidden="true"
                />
            </button>
        );
    }
    return (
        <button
            key={linkID}
            title={t`Toggle ${linkObject.value.title} Menu`}
            aria-haspopup="dialog"
            onClick={(e) => {
                openModal(e, linkObject);
            }}
            className="site-nav__main-menu-item"
            tabIndex={0}
        >
            {/* TODO(i18n): title comes from CMS and should be translated there, not here */}
            {linkObject.value.title}{" "}
            {openedLink === linkObject.value.title ? (
                <SVG
                    src={iconCaretUp}
                    className="site-nav__shop-icon"
                    title={t`Show Menu Icon`}
                    aria-hidden="true"
                />
            ) : (
                <SVG
                    src={iconCaretDown}
                    className="site-nav__shop-icon"
                    title={t`Show Menu Icon`}
                    aria-hidden="true"
                />
            )}
        </button>
    );
};
